// extracted by mini-css-extract-plugin
export default {"grid":"ProductPage_grid__vO0-0","textContainerStyle":"ProductPage_textContainerStyle__UJOtg"};